import styled from '@emotion/styled'
import { useContext } from 'react'
import { Flex } from 'rebass'

import { GameDifficultyContext } from '../../../utils/GameModeContext'
import { isNovice } from '../../../utils/utility'
import { noviceThumbStyling, proThumbStyling } from './ThumbChooserStyles'

const Image = styled('img')`
  position: absolute;
  @media (max-width: 1366px) {
    height: ${({ isNovice }) => (isNovice ? 170 : 240)}px;
  }
`

const ThumbChooserLayoutContainer = styled(Flex)`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`

const ThumbChooserLayout = ({ children }) => {
  const { difficulty } = useContext(GameDifficultyContext)
  const isNoviceMode = isNovice(difficulty)

  return (
    <ThumbChooserLayoutContainer css={isNoviceMode ? noviceThumbStyling : proThumbStyling}>
      <Image
        isNovice={isNoviceMode}
        src={isNoviceMode ? './images/bg-triangle.svg' : './images/bg-pentagon.svg'}
      />
      {children}
    </ThumbChooserLayoutContainer>
  )
}

export default ThumbChooserLayout
